import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SortOrderStrategy } from 'src/app/shared/models/enums/sort-order-strategy.enum';
import { MenuAction } from 'src/app/shared/models/menu-actions/menu-action';
import { patientsActions } from 'src/app/shared/store/patients/patients.actions';
import { selectPatientOrder } from 'src/app/shared/store/patients/patients.selectors';

@Injectable({
  providedIn: 'root',
})
export class PatientOrderService {
  private readonly store = inject(Store);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly translocoService = inject(TranslocoService);

  orderMenuActions: { [key: string]: MenuAction } = {
    [SortOrderStrategy.LAST_ACTIVITY]: {
      title: this.translocoService.translate('Tri par date'),
      testId: 'order-by-last-activity',
      label: this.translocoService.translate('Par ordre de dernière mise à jour'),
      icon: '@tui.clock-arrow-down',
      execute: (): void => this.setPatientOrder(SortOrderStrategy.LAST_ACTIVITY),
    },
    [SortOrderStrategy.ALPHABETICAL]: {
      title: this.translocoService.translate('Tri par nom'),
      testId: 'order-by-name',
      label: this.translocoService.translate('Par ordre alphabétique'),
      icon: '@tui.arrow-down-a-z',
      execute: (): void => this.setPatientOrder(SortOrderStrategy.ALPHABETICAL),
    },
  };

  DEFAULT_ORDER = SortOrderStrategy.LAST_ACTIVITY;
  PATIENT_ORDER_KEY = 'patient-order';

  getPatientOrder(): Observable<SortOrderStrategy> {
    const localOrder = this.localStorageService.get(this.PATIENT_ORDER_KEY) as SortOrderStrategy;
    const isLocalOrderValid = !!localOrder && Object.values(SortOrderStrategy).includes(localOrder);
    if (isLocalOrderValid) {
      this.store.dispatch(patientsActions.setOrder({ order: localOrder }));
    } else {
      this.setPatientOrder(this.DEFAULT_ORDER);
    }

    return this.store.select(selectPatientOrder);
  }

  setPatientOrder(order: SortOrderStrategy): void {
    this.store.dispatch(patientsActions.setOrder({ order }));
    this.localStorageService.set(this.PATIENT_ORDER_KEY, order);
  }
}
